import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiCall from "../../../components/Api";
import StatusComponent from "../../../components/Common/StatusComponent";
import { navBarData, ProductBreadcrumbsList } from "../Const";
import MasterListLayout from "../MasterListLayout";
import { usePaginatedList } from "../MedicineList/utils";

const ProductType = () => {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });
  const [loader, setLoader] = useState(true);

  const {
    records,
    count,
    pages,
    skip,
    limit,
    setLimit,
    handlePageChange,
    handleSortClick,
    debouncedSearch,
    list_api_call,
  } = usePaginatedList({ endpoint: "product-type/list" });

  const handleAdd = () => {
    navigate("/healthsy-services/order-medicines/masters/product-type-form");
  };

  const handleEdit = (id) => {
    navigate(
      `/healthsy-services/order-medicines/masters/product-type-form-edit/${id}`,
    );
  };

  const handleClose = () => {
    setDeleteModal({ id: "", status: false });
  };

  const handleDelete = async (id) => {
    try {
      await apiCall(`product-type/delete/${id}`, "DELETE", null, null);
      list_api_call();
      setDeleteModal({ id: "", status: false });
      message.success("Item deleted successfully");
    } catch (error) {
      setDeleteModal({ id: "", status: false });
      message.error("Failed to delete item");
    }
  };

  const handleActive = async (id, status) => {
    try {
      await apiCall(
        `product-type/update/${id}`,
        "PATCH",
        { active: !status },
        null,
      );
      list_api_call();
      message.success("Status updated successfully");
    } catch (error) {
      message.error("Failed to update status");
    }
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => skip + index + 1,
      key: "serial",
    },
    {
      title: "Status & Actions",
      render: (text, record) => (
        <StatusComponent
          text={text}
          record={record}
          handleEdit={handleEdit}
          setDeleteModal={setDeleteModal}
          handleActive={handleActive}
          title="product_type_name"
        />
      ),
    },
    {
      title: "Product Type Name",
      dataIndex: "product_type_name",
      key: "product_type_name",
    },
  ];

  useEffect(() => {
    records.length > 0 && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <MasterListLayout
      title="Product Type"
      breadcrumbsList={ProductBreadcrumbsList("list")}
      onAdd={handleAdd}
      uploadApi="product-type/create-bulk"
      columns={columns}
      records={records}
      count={count}
      pages={pages}
      skip={skip}
      limit={limit}
      handlePageChange={handlePageChange}
      handleDelete={handleDelete}
      deleteModal={deleteModal}
      setDeleteModal={setDeleteModal}
      handleClose={handleClose}
      setLimit={setLimit}
      handleSortClick={handleSortClick}
      onChangeSearch={debouncedSearch}
      navBarData={navBarData}
      loader={loader}
    />
  );
};

export default ProductType;
